var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ua as useragent } from './platform';
/**
 * @description 将一个支持callback的函数转换成支持promise的
 * @param {Function} fn - 支持callback的函数
 * @param {Object} context - 执行环境
 * @returns {Function}
 */
export function promisefy(fn, context) {
    return function (...args) {
        return new Promise((resolve, reject) => {
            const cb = (err, payload) => {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(payload);
                }
            };
            fn.apply(context, [...args, cb]);
        });
    };
}
/**
 * @description 获取链接参数的值
 * @param {String} url - 链接地址
 * @param {String} name - 参数名称
 * @returns {String} - 参数值
 */
export function getQueryString(url, name) {
    if (!url || !name)
        return;
    return url.match(new RegExp(`(^${name}|[?|&]${name})=([^&#]+)`))
        ? RegExp.$2
        : '';
}
/**
 * @description 数字格式化容量大小
 * @param {Number} bytes 字节数
 * @param {Number} point 小数点保留的位置
 */
export function bytesToSize(bytes, point = 1) {
    if (Number(bytes) <= 0) {
        return '0 B';
    }
    const k = 1024; // or 1024
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const val = bytes / Math.pow(k, i);
    let size = val.toPrecision(3);
    size = val.toFixed(point);
    return size + sizes[i];
}
/**
 * @description 数字格式化容量大小
 * @param {any} size 字节数
 */
export function formatSize(size) {
    size = parseInt(size);
    if (!size) {
        return 0;
    }
    const sizeMap = ['B', 'KB', 'M', 'G', 'T'];
    let index = 0;
    while (size > 1024) {
        size = size / 1024;
        index++;
    }
    size = String(size.toFixed(1));
    if (/(.0)/.test(size))
        size = size.split('.0')[0];
    return `${size}${sizeMap[index]}`;
}
/**
 * @description promise方式的等待定时器
 * @param {number} millisecond 持续时间 ms
 * @returns {Promise<void>} 返回promise
 */
export function sleep(millisecond) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(null);
        }, millisecond);
    });
}
/**
 * @description 判断是否为有效的可下载链接
 * @param {string} url
 */
export function checkValidLink(url) {
    return /^(thunder|magnet|http[s]?|ftp|ed2k):/i.test(url);
}
/**
 * @description 判断是否为json字符串
 * @param {string} str
 */
export function checkIsJSON(str) {
    if (typeof str === 'string') {
        try {
            const obj = JSON.parse(str);
            if (typeof obj === 'object' && obj) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            return false;
        }
    }
    return false;
}
/**
 * @description 转传参数序列化为链接
 * @param {string} url
 * @param {Object} params
 */
export function joinParams(url, params) {
    if (!/\?/.test(url)) {
        url += '?';
    }
    const keyValues = Object.keys(params || {}).map((key) => {
        return `${key}=${params[key]}`;
    });
    return url + keyValues.join('&');
}
/**
 * @description 从秒转成分、钟时间
 * @param {number} ms
 */
export function msToTime(ms) {
    if (ms <= 60)
        return '1分钟';
    else if (ms <= 60 * 60)
        return Math.ceil(ms / 60) + '分钟';
    else if (ms <= 60 * 60 * 24)
        return Math.ceil(ms / 3600) + '小时';
    else
        return Math.ceil(ms / (60 * 60 * 24)) + '天';
}
/**
 * @description 判断时间戳是否是今天
 * @param {any} someDate
 */
export function isToday(someDate) {
    someDate = new Date(someDate);
    const today = new Date();
    return (someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear());
}
/**
 * @description 使用async-await方式，拒绝循环的try-catch
 * @param {Promise<any>} handler
 */
export function promiseHandler(handler) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return [yield handler, null];
        }
        catch (error) {
            return [null, error];
        }
    });
}
/**
 * @description 判断移动平台（微信、QQ、微博、QQ空间、UC浏览器）
 */
export function platform(ua = useragent) {
    let platform;
    if (/MicroMessenger/.test(ua)) {
        platform = 'wx';
    }
    else if (/QQ\//.test(ua)) {
        platform = 'qq';
    }
    else if (/\bWeibo|__weibo__\d/.test(ua)) {
        platform = 'weibo';
    }
    else if (/Qzone\//.test(ua)) {
        platform = 'qzone';
    }
    else if (/UCBrowser/.test(ua)) {
        platform = 'uc';
    }
    else {
        platform = 'other';
    }
    return platform;
}
/**
 *@param 创建下载文件
 * @param {any} blob  ：返回数据的blob对象或链接
 * @param {string} fileName  ：下载后的命名 xx.docx 等
 */
export function downloadFile(blob, fileName) {
    let downloadElement = document.createElement('a');
    let href = blob;
    if (typeof blob == 'string') {
        downloadElement.target = '_blank';
    }
    else {
        href = window.URL.createObjectURL(blob);
    }
    downloadElement.href = href;
    downloadElement.download = fileName;
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    if (typeof blob != 'string') {
        window.URL.revokeObjectURL(href);
    }
}
/**
 * @description 通过 A 标签打开链接
 * @param {string} uri - 需要打开的地址
 */
export function evokeByTagA(uri, isClean = true, target = '_self') {
    const tagA = document.createElement('a');
    tagA.setAttribute('href', uri);
    tagA.setAttribute('target', target); // 在未安装ios手雷时scheme会有问题
    tagA.style.display = 'none';
    // append 在 android 6 系统中有兼容性问题
    // eslint-disable-next-line unicorn/prefer-node-append
    document.body.appendChild(tagA);
    tagA.click();
    isClean && document.body.removeChild(tagA);
}
/**
 * @description 通过 iframe 标签打开链接
 * iframe 模式可以同时支持外部浏览器和迅雷11内部浏览器来调用thunderx协议
 * @param {string} src - 需要打开的地址
 */
export function evokeByIframe(src, timeout = 2000) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    setTimeout(() => document.body.removeChild(iframe), timeout);
}
export function callIOS(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const { type = 'universalLink', target, action, params, from, timeout = 3000, callback, isClean = true, isJustUrl = false, } = data;
        const queryParams = Object.entries(params)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        let href = '';
        const path = `xunlei://${target}/${action}?${queryParams}`;
        if (type === 'scheme') {
            href = path;
        }
        else {
            href = 'oia-pan-ssl.xunlei.com';
            const query = encodeURIComponent(path);
            href = `https://${href}/?query=${query}`;
            if (from) {
                href += `&ct=${from}`;
            }
        }
        if (isJustUrl)
            return href;
        evokeByTagA(href, isClean);
        if (callback) {
            yield sleep(timeout);
            if (!document.hidden)
                callback();
        }
        return;
    });
}
/**
 * @description 在inline web worker中运行函数
 * @param {Function} func - 函数
 * @param {any[]} message - 函数参数
 * @returns {Promise} - 返回Promise对象执行结果
 */
export function promiseWorkerFun(func, ...message) {
    const delegate = () => {
        onmessage = ({ data: { func, message } }) => {
            const wrapper = (fn) => Function('"use strict"; return (' + fn.toString() + ')')();
            const result = wrapper(func)(...message);
            postMessage(result);
        };
    };
    const functionBody = delegate
        .toString()
        .replace(/^[^{]*{\s*/, '')
        .replace(/\s*}[^}]*$/, '');
    return new Promise((resolve, reject) => {
        const worker = new Worker(URL.createObjectURL(new Blob([functionBody], { type: 'text/javascript' })));
        worker.onmessage = ({ data }) => {
            resolve(data);
            worker.terminate();
        };
        worker.onerror = worker.onmessageerror = reject;
        worker.postMessage({ func: func.toString(), message });
        return worker;
    });
}
export function callAndroid(data) {
    return __awaiter(this, void 0, void 0, function* () {
        const { target, action, params, timeout = 3000, callback, isClean = true, isJustUrl = false, } = data;
        let queryParams = '';
        if (params) {
            queryParams = Object.entries(params)
                .map(([key, value]) => `${key}=${value}`)
                .join('&');
        }
        const scheme = 'xunleiapp://xunlei.com';
        let href = '';
        if (action) {
            href = `${scheme}/${target}/${action}?${queryParams}`;
        }
        else {
            href = `${scheme}/${target}?${queryParams}`;
        }
        if (isJustUrl)
            return href;
        evokeByTagA(href, isClean);
        if (callback) {
            yield sleep(timeout);
            if (!document.hidden)
                callback();
        }
        return;
    });
}
/**
 * @description 解析链接参数
*/
export function parseSearch(url = location.search) {
    const theRequest = new Object();
    if (url.indexOf("?") != -1) {
        const str = url.substring(1);
        const strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
}
/**
 * @description head请求获取文件大小
 * @param {string} url - 请求的资源链接
*/
export function fetchSize(url) {
    return fetch(url, { method: 'HEAD' }).then(response => response.headers.get('Content-Length'));
}
/**
 * @description 请求文件用于下载,支持进度
 * @param {string} url - 请求资源链接
 * @param {object} options - 配置
 * @param {function} onprogress - 进度回调
*/
export function fetchFile(url, options = {}, onprogress) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        let response = yield fetch(url, options);
        // @ts-ignore
        const reader = (_a = response.body) === null || _a === void 0 ? void 0 : _a.getReader();
        // @ts-ignore
        const contentLength = +response.headers.get('Content-Length');
        let receivedLength = 0;
        let chunks = [];
        let startTime = Date.now();
        let speed = 0;
        let loaded = 0;
        while (true) {
            // @ts-ignore
            const { done, value } = yield reader.read();
            if (done) {
                break;
            }
            chunks.push(value);
            // @ts-ignore
            receivedLength += value.length;
            speed = Math.round(receivedLength - loaded) / (Date.now() - startTime);
            startTime = Date.now();
            loaded = receivedLength;
            onprogress && onprogress(receivedLength, contentLength, Math.round(speed * 1000));
        }
        let chunksAll = new Uint8Array(receivedLength); // (4.1)
        let position = 0;
        for (let chunk of chunks) {
            // @ts-ignore
            chunksAll.set(chunk, position); // (4.2)
            // @ts-ignore
            position += chunk.length;
        }
        return new Blob(chunks);
    });
}
//# sourceMappingURL=data:application/json;base64,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